import { RiCloseCircleFill } from "react-icons/ri"
import { ImWhatsapp } from 'react-icons/im'
import styled from "styled-components"
import NumberFormat from "react-number-format"


export default function ModalInfoCard(props: any) {
  return (
    <Content>
      <div className="cont">
        <header>
          <span onClick={() => props.closeModal()}><RiCloseCircleFill /></span>
        </header>
        <CardNew
        >
          <div className="contentImage">
            <img
              src={
                props.data.image
                || "https://i.postimg.cc/PrdVR20x/placeholder-image.png"}
              alt="" />
          </div>
          <div className="contentText">
            <h4>
              {props.data.name || 'Sin nombre'}
            </h4>

            {
              props.data.description && (
                <>
                  <hr />
                    <p>Descripción:</p>
                    <p className="description">{props.data.description || ''}.</p>
                  <hr />
                </>
              )
            }
            <p className="text-success pricing">
              RD$
              <NumberFormat
                thousandsGroupStyle="thousand"
                value={props.data.price || "0.0"}
                prefix=""
                decimalSeparator="."
                displayType="text"
                type="text"
                thousandSeparator={true}
                allowNegative={true} />
            </p>
          </div>
        </CardNew>
      </div>
    </Content>
  )
}

const CardNew = styled.div`
    position:relative;
    width: 100%;
    background-color: white;
    display: inline-block;
    white-space: pre-wrap ;
    border-radius: 10px;
    .contentText{
        padding: 1em;
        h4 {
          font-weight: bold;
        }
        .description{
          font-size: 1.1em;
        }
        p{margin:0;}
    }
    .contentImage{
        padding: 1em;
        text-align:center;
        img {
            width: 200px;
            height: 150px;
            object-fit:contain;
        }
    }

`

const Content = styled.div`
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #00000042;
    z-index:10000;
    display:flex;
    flex-direction:column; 
    justify-content:center; 
    align-items:center;
    .cont {
      margin-top: 0 !important;;
        width: 90%;
        min-height: 20vh;
        background:white;
        border-radius: 12px;
        box-shadow: 0px 10px 10px #00000036;
        padding: 2em;
        position: relative;
        ul {
            list-style: none;
            padding: 0!important;
            margin: 0 !important;
        }
    }
    header {
        span {
            position: absolute;
            top: 0;
            right: 5px;
            color: #0000006c !important;
            /* padding: 1em; */
            font-size: 2em;
        }
    }
    span {
        color: #2ecc71;
    }


`